import {CONSONANT_VOWEL_PAIRS_K_G} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_kg";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_K_G_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_K_G} title="Consonant-Vowel Pairs: ㄱ (k/g)" />
     </>
);}